<template>
    <div class="batch">
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <div class="batch-content">
            <batch-label
                :labels="labels"
                @setOptions="setOptions"
                :i="initAction"
                ></batch-label>
            <ul class="options" v-if="options.length && !custom">
                <li
                    class="option"
                    v-for="(value, key) in options"
                    :key="key">
                    {{value.dicValue}}
                </li>
            </ul>
            <me-field
                v-if="custom"
                v-model="message"
                ref="textarea"
                @focus="addEventListenerForInput"
                @blur="removeEventListenerForInput"
                class="options custom-area"
                :style="{paddingBottom: addPadding ? '400PX' : '.7rem', height: addPadding ? 'calc(12rem + 400PX)' : '12rem'}"
                autosize
                label=""
                type="textarea"
                placeholder="请输入选项"/>
        </div>
        <confirm @confirm="confirm"/>
    </div>
</template>
<script>
import batchLabel from '../compontents/label.vue'
import { Questionnaire } from '@/network'
import { parseQueryString } from '@/util/common'
import { removeClass2 } from '@/util/status-util'
import confirm from '../compontents/confirm.vue'
import { getStorage, setStorage } from '@/util/common'
import browser from '@/util/browser'

export default {
    name: 'batch',
    components: { batchLabel, confirm },
    data() {
        return {
            title: '批量添加选项',
            list: [],
            labels: [],
            tid: parseQueryString().tid,
            options: [],
            custom: false,
            message: '',
            initAction: -1,
            isCustomLeft: false,
            addPadding: false,
        }
    },
    created() {
        removeClass2('body', 'loading')
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        this.getLabel()
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        topicId() {
            return this.$route.params.topicId
        },
    },
    methods: {
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                const refTextarea = this.$refs.textarea.$el
                const st = document.documentElement.scrollTop || document.body.scrollTop
                const ot = refTextarea.offsetTop
                const ob = window.innerHeight - ot + st - refTextarea.offsetHeight
                const keyH = 400; //软键盘的高度
                this.addPadding = true
                // if (ob < keyH) {
                //     this.$nextTick(() => {
                //         document.documentElement.scrollTop = st + keyH - ob
                //         document.body.scrollTop = st + keyH - ob
                //     })
                // }
            }
        },
        removeEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                this.addPadding = false
            }
        },
        getLabel() {
            const params = {
                tid: this.tid,
                type: '',
            }
            Questionnaire.batchLabel(params).then((res) => {
                const { data: { data } } = res
                data.push({ typeName: '自定义', custom: true })
                this.labels = data
                this.initData()
            }).catch((error) => {
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        setOptions(item) {
            if (item.custom) {
                this.custom = true
                this.options = []
                return
            }
            this.custom = false
            this.options = item.selectItems
        },
        confirm() {
            if (this.custom) { // 自定义
                //存储
                const message = this.message ? this.message.split('\n') : ''
                if (message && message.length) {
                    const options = getStorage('options') || []
                    message.forEach((item, index) => {
                        item ? this.options.push({ dicValue: item, fileId: options[index] ? options[index].fileId : '', thumbViewUrl: options[index] ? options[index].thumbViewUrl : '' }) : null
                    })
                }
            }
            // 
            setStorage('options', this.options)
            setStorage('options-true', 1)

            this.$router.back({
                name: 'topic2',
                params: {
                    pageId: this.pageId,
                    topicId: this.topicId,
                },
            })
        },
        initData() {
            const options = getStorage('options')
            this.initAction = this.labels.length - 1
            this.custom = true
            if (!options.length) return
            let msg = ''
            options.forEach((item) => {
                item.value ? msg = msg + item.value + '\n' : null
            })
            this.message = msg
        },
    }   
}
</script>
<style scoped>
    .options{
        padding: 0.43rem 0.7rem;
        background: #fff;
        line-height: .8rem;
        font-size: .38rem;
        color: #333333;
    }
    .custom-area{
        height: 12rem;
    }
    .batch-content{
        padding-bottom: 2rem;
    }
    ::v-deep .me-field__body{
        height: 100%;
    }
    ::v-deep .me-field__control{
        height: 100%!important;
        background: #f6f6f6;
        border-radius: 6PX;
        padding: 4px 10px;
    }
</style>
